// Simple Cache System to Improve Performance
class SimpleCache {
  constructor() {
    this.cache = new Map();
    this.timers = new Map(); // To track expiration timers
  }

  // Set a value with an optional TTL (time-to-live) in milliseconds
  set(key, value, ttl = 5 * 60 * 1000) { // Default TTL is 5 minutes
    this.cache.set(key, value);
    
    // Clear any existing timer for this key
    if (this.timers.has(key)) {
      clearTimeout(this.timers.get(key));
    }
    
    // Set a new timer to remove the item after TTL
    if (ttl) {
      const timer = setTimeout(() => {
        this.remove(key);
      }, ttl);
      this.timers.set(key, timer);
    }
    
    return value;
  }

  // Get a value by key
  get(key) {
    return this.cache.get(key);
  }

  // Check if a key exists
  has(key) {
    return this.cache.has(key);
  }

  // Remove a key
  remove(key) {
    // Clear timer if exists
    if (this.timers.has(key)) {
      clearTimeout(this.timers.get(key));
      this.timers.delete(key);
    }
    
    // Remove from cache
    return this.cache.delete(key);
  }

  // Clear all cache
  clear() {
    // Clear all timers
    for (const timer of this.timers.values()) {
      clearTimeout(timer);
    }
    this.timers.clear();
    
    // Clear cache
    this.cache.clear();
  }
  
  // Get cache size
  size() {
    return this.cache.size;
  }
}

// Create a global cache instance
export const cache = new SimpleCache();

// Function to generate cache keys based on function and parameters
export const generateCacheKey = (fnName, params) => {
  return `${fnName}:${JSON.stringify(params)}`;
};